/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/column_chooser.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    columnChooserModule
} from "../../../grids/grid_core/column_chooser/m_column_chooser";
import gridCore from "../m_core";
export var ColumnChooserController = columnChooserModule.controllers.columnChooser;
export var ColumnChooserView = columnChooserModule.views.columnChooserView;
gridCore.registerModule("columnChooser", columnChooserModule);
